function elevationShadowStyle(elevation: number) {
  return {
    elevation,
    shadowColor: 'black',
    shadowOffset: { width: 0, height: 0.5 * elevation },
    shadowOpacity: 0.3,
    shadowRadius: 0.8 * elevation,
  };
}

export default {
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  inner: {
    flex: 1,
    justifyContent: 'flex-start',
    //bottom: 25
  },
  form: {
    flex: 1,
    justifyContent: 'center',
    width: '60%',
    alignContent: 'center',
    alignSelf: 'center',
    position: 'relative',
  },
  horizContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    height: 30,
    width: 60,
    resizeMode: 'contain',
  },
  welcomeContainer: {
    alignItems: 'center',
    paddingTop: 20,
    paddingBottom: 20,
  },
  shadow: {
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 7,
    },
    shadowOpacity: 0.43,
    shadowRadius: 9.51,
    elevation: 15,
  },
  shadow1: elevationShadowStyle(5),
  shadow2: elevationShadowStyle(10),
  shadow3: elevationShadowStyle(20),
  box: {
    borderRadius: 8,
    backgroundColor: 'white',
    padding: 0,
  },
  headerText: {
    fontSize: 20,
  },
  titleText: {
    fontWeight: 700,
    fontSize: 36,
  },
  row: {
    flex: 1,
    justifyContent: 'space-around',
  },
  centeredContent: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  activityIndicator: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    height: 80,
  },
};

export const noSelect = { userSelect: 'none', WebkitUserSelect: 'none' };
export const noPtrEvts = { pointerEvents: 'none' };
export const disableLongPressBS = { userSelect: 'none', WebkitUserSelect: 'none', WebkitTouchCallout: 'none' };

export const moxiVerdigris = '#1AA2B0';
export const moxiVerdigrisGradient =
  'radial-gradient(100% 100% at 50% 0%, rgba(26, 162, 176, 0) 63.54%, #1A8EAB 100%), linear-gradient(19.68deg, #1AA2B0 10.73%, #1AA2B0 47.33%, #1AA2B0 65.82%, #3BB8C5 89.68%)';
export const moxiGreen1 = '#318b8d';
export const confirmColor = moxiVerdigris;
export const confirmBorderColor = '#1A8EAB';
export const cancelColor = '#C04544';

export const pleasantGreen = '#41b545';
export const pleasantOrange = '#9f6c0e';
export const alertRed = '#e8454c';


export const ellipsify = { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };

// export const wpStyle = {fontWeight:'bold'};
// export const wpStyle = {textDecoration:'underline dotted #47b7b9'};
export const wpStyle = { fontSize: '1.15em', color: moxiGreen1 };
//#47b7b9  //  318b8d

export const boxyShadow = { boxShadow: '#bbb 0px 0px 30px' };

export const noTouchAction = { touchAction: 'none' };
export const panY = { touchAction: 'pan-y' };

export const turqoiseBtnStyle = more => ({backgroundColor:'#47b7b9', color:'white', 
    fontSize:30, minWidth:'4em', textAlign:'center',
    borderRadius:40, fontWeight:'bold', cursor:'pointer', 
    paddingTop:3, paddingBottom:3, paddingLeft:10, paddingRight:10, ...noSelect, ...more});